import { NonEmpty } from '../../../../../../../common/util/arrays/NonEmpty';

const SEPARATOR = ', ';

export const summarise = (values: NonEmpty<readonly string[]>, maxLength: number) => {
  // Figure out how much of the array can fit concatenated within the allowed length
  const [firstValue, ...remainingValues] = values;
  const displayedValues = [firstValue];
  let length = firstValue.length;

  for (const value of remainingValues) {
    const nextLength = length + value.length + SEPARATOR.length;
    if (nextLength >= maxLength) break;
    displayedValues.push(value);
    length = nextLength;
  }

  return {
    display: displayedValues.join(SEPARATOR),
    more: values.length - displayedValues.length,
  };
};
